import React, { useEffect, useState } from "react";
import { ApisService } from "../../../../../app/core/apis.service";
import {
  dataDecrypt,
  encrypt,
} from "../../../../../app/utility/encryption-helper";
import { DataTable } from "../../../../../components/data-table";
import { TransactionsDataGridCols } from "./data-grid-cols";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import { getMonthStartAndEndDates } from "../../../../../app/utility/monthStartEndDate";
import { FirstLetterCapitalize } from "../../../../../components/custom-methods/first-letter-capitalise";

export const OrdersList = () => {
  const { startDate, endDate } = getMonthStartAndEndDates();
  const params = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState("");
  const [fromDate, setFromDate] = useState<any>(startDate);
  const [toDate, setToDate] = useState<any>(endDate);
  const [transactionsData, setTransactionsData] = useState<any>([]);
  const initialPayload = {
    buId: params.org,
    filters: {
      DateFrom : startDate,
      DateTo: endDate,
      status: null,
      name: null,
      transaction_type: "",
      offline: null,
      limit: 10,
      page: 0,
    },
  };
  const [pageCount, setPageCount] = useState<any>(initialPayload);
  useEffect(() => {
    loadTransactions(initialPayload);
  }, []);
  async function loadTransactions(payload: any): Promise<void> {
    setLoading(true);
    try {
      const encryptedData = encrypt(JSON.stringify(payload));
      const res = await ApisService.transactionApi(
        "findByTransactionBuId",
        encryptedData
      );
      const transactionsData = JSON.parse(dataDecrypt(res.data.data));
      const response = transactionsData?.results;
      console.log(transactionsData);
      if (transactionsData !== "No data found") {
        const results = response.filter(
          (order: any) => order.type === "ONDC"
        );
        const data = { results: results };
        console.log(data);
        const orderData = { ...transactionsData, ...data };
        orderData.results.forEach((element: any) => {
          element.date = moment(element?.created_date).format("DD-MM-YYYY");
          element.name = element?.buyer?.name;
          element.buyer_app = element?.ondc?.buyer_app;
          element.status_of_order = element?.invoice_details?.length > 0 ? FirstLetterCapitalize(element?.invoice_details[0]?.status) : FirstLetterCapitalize(element?.status);
          element.details = <button className="primary-bg text-white rounded px-4 py-1 border-0" onClick={() => handleViewOrder(element.id)}>View</button>
        });
        setTransactionsData(orderData);
      }
      else {
        setTransactionsData({ results: [] });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }


  const onPageChange = (data: any) => {
    let payload = { filters: { limit: 10, page: data, name: inputValue, DateFrom : fromDate, DateTo: toDate } };
    setPageCount(payload);
    loadTransactions(payload);
  };

  const onSelectPage = (data: any) => {
    let payload = { filters: { limit: 10, page: data, name: inputValue, DateFrom : fromDate, DateTo: toDate } };
    setPageCount(payload);
    loadTransactions(payload);
  };

  const onSearchData = () => {
    if (inputValue || fromDate || toDate) {
      let payload: any = {
        buId: params.org,
        filters: {
          DateFrom : fromDate? fromDate : null,
          DateTo: toDate ? toDate : null,
          status: null,
          name: inputValue ? inputValue : null,
          transaction_type: null,
          offline: null,
          limit: 10,
          page: 0
        },
      };
      loadTransactions(payload);
    } else {
    }
  };

  const onClear = () => {
    setInputValue("");
    loadTransactions(initialPayload);
    setPageCount(initialPayload);
    setFromDate(startDate);
    setToDate(endDate);
  };


  const handleChange = (e: any) => {
    let payload = { filters: { limit: 10, page: 0, name: e.target.value, DateFrom: fromDate, DateTo: toDate } };
    loadTransactions(payload);
    setInputValue(e.target.value);
  }

  const selectFromDate = (e: any) => {
    setFromDate(e.target.value);
  }

  const selectToDate = (e: any) => {
    setToDate(e.target.value)
  }

  const handleViewOrder = (id: string) => {
    navigate(`/dashboard/organizations/org-details/${params.org}/ondc-orders/${id}/view`);
    
  };

  return (
    <div>
      <h5 className="mt-3 mb-2 fw-bold">ONDC Orders</h5>
      <div className="row mx-1">
        <input type="text" className="form-control  mt-2" value={inputValue} onChange={handleChange} placeholder="Search ..." />
        <div className="row mt-2">
          <div className="col-md-5 mb-2 ps-0">
            <input type="date" className="form-control" value={fromDate} onChange={selectFromDate} />
          </div>
          <div className="col-md-5 mb-2">
            <input type="date" className="form-control" value={toDate} min={fromDate} onChange={selectToDate} />
          </div>
          <div className="col-md-1 mb-2"><button className="form-control primary-bg text-white w-100" onClick={onSearchData}>Search</button></div>
          <div className="col-md-1 mb-2"><button className="form-control primary-bg text-white w-100" onClick={onClear}>Clear</button></div>
        </div>
      </div>
      <div className="col-12 px-0 my-2">
        {loading ? (
          <div className="text-center p-5">
            <div className="spinner-border" role="status">
              <span className="sr-only"></span>
            </div>
          </div>
        ) : (
          <DataTable
            tableData={transactionsData}
            TableCols={TransactionsDataGridCols}
            onActions={(e: any) => { }}
            onPageChange={(e: any) => onPageChange(e)}
            onSelectPageChange={(e: any) => onSelectPage(e)}
            pageCount={pageCount}
            pagination={true}
          />
        )}
      </div>
    </div>
  );
};
